export const environment = {
  production: true,
  apiUrl: 'https://statz-api.server018.com/api',
  keycloak: {
    url: 'https://statz-auth.server018.com',
    realm: 'statz-admin',
    clientId: 'statz-backoffice'
  }
};
